module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Estamos analisando suas informações","subtitle":"Agora é só aguardar. Em algumas horas o resultado da análise vai estar disponível.","updated_at":"Atualizado em {date} ás {time}"},"en-US":{"title":"We are analyzing your information","subtitle":"Now just wait. In a few hours the results of the analysis will be available.","updated_at":"Updated on {date} ata {time}"}}')
  delete Component.options._Ctor
}
